import { Grid } from "@mui/material";
import ClientCard from "components/ui/ClientFlow/ClientCard";
import React, { useEffect, useState } from "react";
import { useGlobalContext } from "context/GlobalContext";
import { Outlet, useLocation, useParams } from "react-router-dom";
import apiClient from "lib/api-client";
import { useQuery } from "@tanstack/react-query";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";

function modifiedData(purchasedData) {
  let newData = purchasedData.map((entry) => {
    let icon = entry?.label?.includes("Category") ? "By Category" : entry.label.includes("Collection") ? "By Collection" : entry.label.includes("Partial") ? "By PartialSets" : "By Sets";

    return {
      ...entry,
      name: entry.label,
      icon,
    };
  });

  return newData;
}

const ClientsPurchases = () => {
  const { clientId } = useParams();
  const [cardData, setCardData] = useState([]);

  const {
    setFilterChangeCount,
    setDisplayCount,
    setFilterChangeDesignCount,
    setSearchResultCount,
    setSearchSuffix,
    setDynamicFilterCount,
    dynamicfilterCount,
    filterChangeCount,
    filterChangeDesignCount,
    search,
  } = useGlobalContext();

  //React Query

  const fetchPurchaseData = async (clientCode) => {
    let data = await apiClient.get(`/api/v9/myBinnys/getSingleClientAllPurchaseData/${clientCode}`);
    return data?.data?.data;
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ["purchaseData", clientId],
    queryFn: () => fetchPurchaseData(clientId),
    enabled: !!clientId,
  });

  useEffect(() => {
    if (data) {
      setCardData(modifiedData(data?.data));
    }
  }, [data]);

  useEffect(() => {
    let totalCountPurchase = 0;

    cardData.forEach((entry) => (totalCountPurchase += entry?.count));

    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(totalCountPurchase);
      setFilterChangeDesignCount(data?.totalDesignCount)
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
      setFilterChangeDesignCount(data?.totalDesignCount)
    }
    setDisplayCount(true);
    setSearchSuffix("Designs");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [search, cardData]);

  if (isLoading) return <LoadingSmallCard count={4} height={102} />;
  if (error) return <p>Error fetching data</p>;

  return (
    <div style={{ color: "yellow" }}>
      <Grid container spacing={2} marginTop={3} marginLeft={1} sx={{ display: "flex", gap: "2rem" }}>
        {cardData.length > 0 &&
          cardData.map((data) => {
            return (
              <Grid item sx={{ padding: "0px !important" }}>
                <ClientCard data={data} showLine={false} page="purchase" />
              </Grid>
            );
          })}
      </Grid>
      <Outlet />
    </div>
  );
};

export default ClientsPurchases;
